import { create } from "zustand";
import { persist } from "zustand/middleware";

export type GranularityMode = "daily" | "15m";

interface GranularityState {
  mode: GranularityMode;
  setMode: (mode: GranularityMode) => void;
}

export const useGranularityMode = create(
  persist<GranularityState>(
    (set) => ({
      mode: "15m", // Default to existing 15-minute interval behavior
      setMode: (mode: GranularityMode) => set({ mode }),
    }),
    {
      name: "schedule-granularity",
    }
  )
);
